import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import SystemMessageHub, { SystemMessageCallbacks } from '../../hubs/SystemMessage/SystemMessageHub.ts';
import { BaseAlert } from '@cks-internal/react-base';

interface SystemMessage {
  id: string;
  message: string;
  type: 'deployment' | 'general';
  timestamp: Date;
}

const SystemMessageNotification: React.FC = () => {
  const [message, setMessage] = useState<SystemMessage | undefined>(undefined);
  const hubRef = useRef<SystemMessageHub | null>(null);

  useEffect(() => {
    const callbacks: SystemMessageCallbacks = {
      onDeploymentNotification: (message: string) => {
        const newMessage: SystemMessage = {
          id: `deployment-${Date.now()}`,
          message,
          type: 'deployment',
          timestamp: new Date()
        };
        setMessage(newMessage);
      },
      onGeneralMessage: (message: string) => {
        const newMessage: SystemMessage = {
          id: `general-${Date.now()}`,
          message,
          type: 'general',
          timestamp: new Date()
        };
        setMessage(newMessage);
      }
    };

    hubRef.current = new SystemMessageHub(callbacks);
    hubRef.current.start().then();

    return () => {
      if (hubRef.current) {
        hubRef.current.stopConnection();
      }
    };
  }, []);

  const handleDismiss = () => {
    setMessage(undefined);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!message) {
    return null;
  }

  return (
    <Box position='fixed' top={0} left={0} right={0} zIndex={9999} p={2}>
      <BaseAlert
        key={message.id}
        status={message.type === 'deployment' ? 'warning' : 'info'}
        mb={2}
        borderRadius='md'
        boxShadow='md'>
        <Flex alignItems='center' justifyContent='space-between'>
          {message.message}
          <Box>
            {message.type === 'deployment' ? (
              <Button aria-label='Refresh application' size='sm' colorScheme='orange' onClick={handleRefresh} ml={2}>
                Refresh
              </Button>
            ) : (
              <Button aria-label='Refresh application' size='sm' colorScheme='orange' onClick={handleDismiss} ml={2}>
                Close
              </Button>
            )}
          </Box>
        </Flex>
      </BaseAlert>
    </Box>
  );
};

export default SystemMessageNotification;
